import WsService from "../WsService";
import InitiatePaymentResponse from "../../domain/digipay/InitiatePaymentResponse";

const ENDPOINT_BASE = "/digi-pay/init";

export default class DigiPayPaymentService {

    static initiatePayment(transactionId) {
        let url = ENDPOINT_BASE + '?transactionId=' + transactionId;
        return WsService.post(url, {}, 200).then(
            response => {
                return new InitiatePaymentResponse(response);
            },
            error => {
                return error;
            }
        )

    }
}